import * as Yup from "yup";

export const initialInviteValues = {
    name: "", email: "", phone: ""
}

export const inviteSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email format").trim().required("Email is a required field"),
    phone: Yup.number().typeError("Only digit(s) is allowed").required("Phone number is a required field"),
});